require('./bootstrap');

window.cookieconsent.initialise({
    palette: {
        popup: {
            background: '#040309',
            text: '#F68B29',
        },
        button: {
            background: '#F68B29',
            text: '#FFFFFF'
        }
    },
    theme: 'classic',
    content: {
        message: 'Această pagină web folosește cookie-uri pentru a îmbunătăți experiența de navigare și a asigura funcționalități adiționale.',
        dismiss: 'Accept',
        link: 'Detalii',
        href: '/despre-cookies'
    }
});

const gallery_element = document.getElementById('gallery');

if(gallery_element) {
    const gallery = new Viewer(gallery_element, {
        backdrop: 'static',
        title: false,
        rotatable: false,
        scalable: false,
        transition: true,
    });

    $('#open-gallery').on('click', function () {
        gallery.show();
    });
}
